import { WealthEvolutionAction } from './wealth-evolution.action';

export class WealthEvolutionState {
    public loadingWealthEvolutionHistoryPendingRequests: number;
    public wealthEvolutionHistory: any;
    public interval: number;
    public userHasPosition: boolean;
    public pending: boolean;
}

export const initialState: WealthEvolutionState = {
    loadingWealthEvolutionHistoryPendingRequests: 0,
    wealthEvolutionHistory: [],
    interval: 0,
    userHasPosition: false,
    pending: false,
};

export function WealthEvolutionReducer(
    state: WealthEvolutionState = initialState,
    action?: WealthEvolutionAction
) {
    switch (action.type) {
        // verifica se o usuário possui patrimônio (busca)
        case WealthEvolutionAction.checkUserHasPosition:
            return { ...state, ...{ pending: true } };

        // verifica se o usuário possui patrimônio (resultado)
        case WealthEvolutionAction.checkUserHasPositionSuccess:
            return {
                ...state,
                ...{
                    pending: false,
                    userHasPosition: action.payload,
                },
            };

        // verifica se o usuário possui patrimônio (erro)
        case WealthEvolutionAction.checkUserHasPositionError:
            return {
                ...state,
                ...{
                    pending: false,
                    userHasPosition: action.payload,
                },
            };

        // histórico de evolução patrimonial (busca)
        case WealthEvolutionAction.getLastThreeMonthsHistory:
        case WealthEvolutionAction.getLastSixMonthsHistory:
        case WealthEvolutionAction.getLastOneYearHistory:
        case WealthEvolutionAction.getLastThreeYearsHistory:
        case WealthEvolutionAction.getFromBeginningHistory:
            return {
                ...state,
                ...{
                    loadingWealthEvolutionHistoryPendingRequests:
                        state.loadingWealthEvolutionHistoryPendingRequests + 1,
                },
            };

        // histórico de evolução patrimonial (resultado)
        case WealthEvolutionAction.getLastThreeMonthsHistorySuccess:
        case WealthEvolutionAction.getLastSixMonthsHistorySuccess:
        case WealthEvolutionAction.getLastOneYearHistorySuccess:
        case WealthEvolutionAction.getLastThreeYearsHistorySuccess:
        case WealthEvolutionAction.getFromBeginningHistorySuccess:
            return {
                ...state,
                ...{
                    loadingWealthEvolutionHistoryPendingRequests:
                        state.loadingWealthEvolutionHistoryPendingRequests - 1,
                    wealthEvolutionHistory: {
                        ...state.wealthEvolutionHistory,
                        ...{[action.payload.interval]: action.payload.data},
                    },
                    interval: action.payload.interval,
                },
            };

        // histórico de evolução patrimonial (erro)
        case WealthEvolutionAction.getLastThreeMonthsHistoryError:
        case WealthEvolutionAction.getLastSixMonthsHistoryError:
        case WealthEvolutionAction.getLastOneYearHistoryError:
        case WealthEvolutionAction.getLastThreeYearsHistoryError:
        case WealthEvolutionAction.getFromBeginningHistoryError:
            return {
                ...state,
                ...{
                    loadingWealthEvolutionHistoryPendingRequests:
                        state.loadingWealthEvolutionHistoryPendingRequests - 1,
                    wealthEvolutionHistory: {
                        [action.payload.interval]: action.payload.data,
                    },
                    interval: action.payload.interval,
                },
            };

        case WealthEvolutionAction.resetWealthEvolutionState:
            return {...state, ...{ wealthEvolutionHistory: [] } };

        default:
            return state;
    }
}
